var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-competence-cards-batch-page" }, [
    _c(
      "div",
      { staticClass: "o-width-limiter" },
      [
        _c(
          "can",
          { attrs: { i: "manage", a: "CompetenceCard" } },
          [
            _c("div", { staticClass: "t-margin-bottom-m" }, [
              _vm.$can("manage", "CompetenceCard")
                ? _c(
                    "button",
                    {
                      staticClass: "c-button c-button--linkstyle",
                      on: {
                        click: function($event) {
                          return _vm.$router.back()
                        }
                      }
                    },
                    [_vm._v("Tillbaka")]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("competence-cards-batch-data-provider", {
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(dataProvider) {
                    return _c(
                      "div",
                      {},
                      [
                        !dataProvider.showBatchSuccessMessage
                          ? _c(
                              "h1",
                              {
                                staticClass:
                                  "t-text-style-alpha t-margin-bottom-m"
                              },
                              [_vm._v("Lägg till kurs för flera medarbetare")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        dataProvider.loading
                          ? _c("div", { staticClass: "c-spinner" })
                          : _vm._e(),
                        _vm._v(" "),
                        !dataProvider.loading
                          ? [
                              _c("competence-card-batch-course", {
                                attrs: {
                                  mode: "create",
                                  showBatchSuccessMessage:
                                    dataProvider.showBatchSuccessMessage,
                                  "competence-cards":
                                    dataProvider.competenceCards,
                                  courseOptions: dataProvider.courseOptions
                                },
                                on: {
                                  addCourseBatch: dataProvider.batchAddCourse,
                                  closeSuccessMessage:
                                    dataProvider.toggleBatchSuccessMessage
                                }
                              })
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        !_vm.$can("manage", "CompetenceCard")
          ? _c(
              "p",
              {
                staticClass:
                  "t-text-style-beta t-margin-bottom-s t-margin-top-s"
              },
              [
                _vm._v(
                  "\n            För att få tillgång till IN Kompetensverktyg behöver du vara administratör av tjänsten."
                ),
                _c("br"),
                _vm._v(
                  "\n            Kontakta tjänsteadministratören på ditt företag om du vill se din kompetensprofil eller skriva ut ett kompetenskort.\n        "
                )
              ]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }